<template>
    <div class="mb-6">
        <Modal :show="showUserSelectionModal"
               :on-close-click="closeUserSelection"
               :on-save-click="closeUserSelection"
               modal-title="Vyberte člena">
            <div>
                <div v-for="user in users"
                     @click="() => selectTaskUser(user)"
                     class="my-4 rounded-full py-1 px-2 flex items-center cursor-pointer transition hover:shadow"
                     :class="selectedPerson.id === user.id ? 'bg-gray-100' : ''"
                     v-ripple>
                    <div class="flex w-10 h-10 bg-gray-200 rounded-full items-center justify-center text-sm text-white"
                         :class="'bg-'+user.color">
                        {{ getInicials(user) }}
                    </div>
                    <div class="ml-4 text-gray-600">
                        {{ user.name }}
                    </div>
                </div>
            </div>
        </Modal>
        <!-- Header -->
        <div class="relative bg-gray-100 overflow-hidden shadow flex items-center cursor-pointer mb-6 rounded-full py-2 px-3 text-sm">
            <div @click="expandGroup" class="flex items-center w-full text-black" :class="(group.done_progress === group.tasks.length ) && group.tasks.length !== 0 ? 'text-white' : ''" :style="{zIndex: '11'}">
                <div class="flex">
                    <i class="material-icons transition" :class="{'fa-rotate-90': !expanded, 'fa-rotate-270': expanded}">chevron_right</i>
                </div>
                <div class="ml-1">{{ group.name }}</div>
                <div class="ml-4" v-if="group.due_date" > Do {{ due_date }}</div>
                <div class="ml-auto">{{ group.done_progress }} / {{ group.tasks.length }}</div>
            </div>
            <div>
                <md-button @click="() => removeList(group)" class="md-icon-button dense">
                    <md-icon>delete</md-icon>
                </md-button>
            </div>
            <div class="absolute bottom-0 left-0 top-0 rounded-full transition"
                 :class="group.done_progress === group.tasks.length ? 'bg-green-400' : 'bg-gray-200'"
                 :style="{zIndex: '10', width: ( (group.done_progress / group.tasks.length ) * 100)+'%'}"></div>
        </div>
        <!-- Body -->
        <transition-collapse>
            <div v-show="expanded" class="flex-col pl-6" :class="expanded ? `flex` : ''">
                <div>
                    <TaskItem v-for="task in filteredTasks"
                              :key="'task'+task.id"
                              :task="task"
                              :move="updateTask"
                              :update="updateTask"
                              :on-delete="deleteTask" />
                </div>
                
                <form @submit="submitNewTask"
                      class="flex items-center w-full border-b border-gray-100 hover:shadow rounded-full overflow-hidden mt-6 text-sm">
                    <div class="w-4/6">
                        <input type="text" v-model="content" placeholder="Task" class="w-full pl-4 text-gray-600">
                    </div>
                    <div class="w-2/6 flex items-center">
                        <div
                             class="ml-auto flex items-center justify-center rounded-full py-1 hover:shadow cursor-pointer overflow-hidden"
                             :class="hasSelectedPerson ? 'bg-gray-100 pl-1 pr-3' : 'px-1'"
                             v-ripple>
                            <div @click="openUserSelection" class="flex items-center">
                                <span class="flex rounded-full items-center justify-center w-8 h-8" :class="hasSelectedPerson ? `bg-${selectedPerson.color} text-white` : ''">
                                    <i class="material-icons">person</i>
                                </span>
                                <span class="text-xs ml-2 text-gray-700" v-if="hasSelectedPerson">{{ selectedPerson.name }}</span>
                            </div>
                            <span @click="() => this.selectedPerson = {}" v-if="hasSelectedPerson"
                                  class="flex w-4 h-4 rounded-full bg-gray-500 text-gray-200 flex items-center justify-center"
                                  :class="{'ml-2': hasSelectedPerson }"><i class="text-xs material-icons">close</i></span>
                        </div>
                        <button type="submit" class="ml-3 mr-2 w-10 h-10 hover:shadow text-orange-500 flex items-center justify-center rounded-full">
                            <font-awesome icon="arrow-right"></font-awesome>
                        </button>
                    </div>
                </form>
            </div>
        </transition-collapse>
    </div>
</template>

<script>
    import TransitionCollapse from '../../../components/TransitionCollapse'
    import Checkbox from "../../../components/Checkbox";
    import {getInicials, shortifyName} from "../../../utils";
    import {mapState} from "vuex";
    import moment from 'moment';
    import TaskItem from "./TaskItem";
    
    export default {
        name: "TaskGroup",
        components: {
            TransitionCollapse, Checkbox, TaskItem
        },
        
        props: {
            group: {
                type: Object,
                required: true
            },
            format: {
                type: String,
                default: "DD.MM.YYYY"
            }
        },
        
        mounted() {
            if (this.showOnlyUncompleted) {
                this.filteredTasks = this.group.tasks.filter((e) => {
                    return !e.done;
                });
            }else {
                this.filteredTasks = this.group.tasks;
            }
        },
        
        data: () => ({
            expanded: false,
            content: '',
            
            // modal
            showUserSelectionModal: false,
            selectedPerson: {},

            showOnlyUncompleted: false,
            filteredTasks: []
        }),
        
        computed: {
            ...mapState({
                project: state => state.projects.single,
                users: state => state.users.all
            }),
            
            due_date() {
                if (!this.group.due_date) return null;
                return moment.unix(this.group.due_date).format(this.format);
            },
            
            hasSelectedPerson() {
                return Object.keys(this.selectedPerson).length > 0;
            },
        },
        
        methods: {
            expandGroup() {
                this.expanded = !this.expanded
            },
            
            getInicials(u) {
                return getInicials(u.name, u.image);
            },
            shortifyName(n) {
                return shortifyName(n);
            },
            
            submitNewTask(e) {
                e.preventDefault();
                this.$store.dispatch("newTask", {
                    content: this.content,
                    user_id: this.hasSelectedPerson ? this.selectedPerson.id : null,
                    project_id: this.project.id,
                    task_group_id: this.group.id,
                    done: false,
                    priority: 1.0
                }).then(() => {
                    this.content = '';
                    this.selectedPerson = {};
                    this.$emit('submit', e);
                });
                
            },
            
            // modal
            openUserSelection() {
                this.showUserSelectionModal = true;
            },

            closeUserSelection() {
                this.showUserSelectionModal = false;
            },
            selectTaskUser(user) {
                this.selectedPerson = user;
                this.closeUserSelection();
            },
            updateTask(task) {
                this.$store.dispatch("updateTask", task)
                    .then(() => {
                        this.$emit('submit');
                    });
            },
            deleteTask(task) {
                this.$store.dispatch("deleteTask", task)
                    .then(() => {
                        this.$emit('submit');
                    });
            },
            
            removeList(group) {
                this.$store.dispatch("deleteGroup", group)
                        .then(() => {
                            this.$emit('submit');
                        });
            }
        },

        watch: {
            group: function () {
                if (this.showOnlyUncompleted) {
                    this.filteredTasks = this.group.tasks.filter((e) => {
                        return !e.done;
                    });
                }else {
                    this.filteredTasks = this.group.tasks;
                }
            }
        },
    }
</script>

<style scoped>

</style>